import { Box, Tooltip, Typography } from "@mui/material"
import { TextTitle } from "../../components/atoms/text/titles"
import { useEffect, useState } from "react"
import { FetchFromBackoffice } from "../../utils/request"
import { useRecipeDefinitions } from "./_hooks/useRecipeDefinitions"

type Recipe = {
    articleNumber: string,
    name: string, 
    version: number
}

const RecipeTags = ({ recipeTags }: { recipeTags?: Array<{name:string, color_code:string}> | undefined }) => {

  return (
  <Box style={{ display: "flex", flex: 1, marginBottom: "3px", gap: "4px"}}>
    {    recipeTags?.map((tag) => (
        <Tooltip title={ tag.name }>
          <Box>
            <div style={{ width: "14px", height: "14px", backgroundColor: tag.color_code, borderRadius: "50%" }}></div>
          </Box>
        </Tooltip>
    ))}
    </Box>
  )
}

export const HubRecipes = ({ serialId }: { serialId?:string }) => {
  const [recipes, setRecipes] = useState<Recipe[]>([])
  const definitions = useRecipeDefinitions()


  useEffect(() => {
    if (serialId) {
      FetchFromBackoffice<Recipe[]>(`machines/${serialId}/recipes/installed`)
      .then(data => {
          setRecipes(data)
      }).catch(e => {
          console.warn("Error: ", e)
          setRecipes([])
        })
      }
    }, [serialId])

  return (
    <Box style={{ flex: 2, marginBottom: "10px"}}>

      <TextTitle title="Installed recipes" />
      {recipes.length === 0 ? 
        <Box sx={{display:"flex", flexDirection: "row", alignItems:"center", gap: "5px"}}>
            <Typography>{"No installed recipes"}</Typography>
          </Box> :
        recipes.map((recipe: Recipe)=> (
           <Box sx={{display:"flex", flexDirection: "row", alignItems:"center", gap: "5px"}}>
            <Typography>{recipe.name}</Typography>
            <Typography >{`(${recipe.articleNumber} v${recipe.version})`}</Typography>
            <RecipeTags recipeTags={definitions?.find((t: any) => t.article_number === recipe.articleNumber)?.tags}/>
          </Box>
        ))}
      
    </Box>
  )
}